import styled from 'styled-components';
import CoupleFriendlyIconSvg from '../assets/hotels/amenities/couple-friendly.svg';

const CoupleFriendlyIcon = styled(
  CoupleFriendlyIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props =>
    props.fill || (props.isActive ? props.theme.colors.red.base : props.theme.colors.grey.grey50)};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default CoupleFriendlyIcon;
